// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BtnAjoutPanier_wrapper__2pZZq","picto":"BtnAjoutPanier_picto__aqL6N"};